import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ResignationRule  {
    _originalTypeClassName = "zERP.BO.ResignationRule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ResignationRule.translate = translateService;
}
this.ApprovalFlow = new Domain.ApprovalFlow();
this.Id = null;
this.Name = null;
this.Abbreviation = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Abbreviation:any;
Notes:any;
ApprovalFlow:any;
static setApprovalFlow = ($this, value) => {
var oldValue = $this.ApprovalFlow;
$this.ApprovalFlow = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}